import { Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { isDoctor } from '../services/authService';

function ProtectedRoute({ children }) {
    const [loading, setLoading] = useState(true);
    const [authorized, setAuthorized] = useState(false);
    
    useEffect(function() {
        async function checkAuth() {
            try {
                const authToken = localStorage.getItem('authToken');
                if (!authToken) {
                    setAuthorized(false);
                    setLoading(false);
                    return;
                }
                
                const doctorStatus = await isDoctor();
                setAuthorized(doctorStatus);
            } catch (error) {
                setAuthorized(false);
            } finally {
                setLoading(false);
            }
        }
        
        checkAuth();
    }, []);

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    if (!authorized) {
        return <Navigate to="/" replace />;
    }

    return children;
}

export default ProtectedRoute; 